angular.module('content.widgets.ContentWidgetService', [
])

/**
 * The ContentWidgetService service handles scoring and
 * feedback for the state.contentView type
 *
 * @class ContentWidgetService
 * @constructor
 * @module content.widgets.ContentWidgetService
 */
.factory('ContentWidgetService', [
  'StatesService',
  'ModelsService',
  function (StatesService, ModelsService) {
    'use strict';

    var service = {

      score: {
        points: {
          current: 0,
          total: 0
        }
      },

      /**
       * Processes the scoring and feedback of
       * state.contentView item types.
       *
       * @param {string} stateId - ID of the state
       * @param {string} triggerId - ID of the selected trigger
       * @return {Object} Full feedback object resulting from process
       */
      process: function process(stateId, triggerId) {
        var rules;
        var ruleIndex;
        var rule;
        var choices;
        var choiceIndex;
        var choice;

        var feedback = {
          points: {
            earned: 0,
            total: 0
          },
          targetId: null,
          correctFeedback: null,
          incorrectFeedback: null,
          choiceFeedback: null
        };

        console.log('ContentWidgetService: process: stateId', stateId);
        console.log('ContentWidgetService: process: trigger', triggerId);
        console.log('ContentWidgetService: process: state', StatesService.get(stateId));

        // TODO: Find a better way to structure this for loop block
        rules = StatesService.get(stateId).content.rules;
        for (ruleIndex = 0; ruleIndex < rules.length; ruleIndex += 1) {
          rule = rules[ruleIndex];
          if (rule.content.active) {
            // handle scoring if applicable
            if (rule.content.scored) {
              feedback.points.total += rule.content.totalPoints;
            }

            choices = rule.content.decision.choices;
            for (choiceIndex = 0; choiceIndex < choices.length; choiceIndex += 1) {
              choice = choices[choiceIndex];
              if (choice.id === triggerId) {
                if (rule.content.scored && choice.correct) {
                  feedback.points.earned += choice.points;
                }
                if (choice.target && choice.target !== '_self') {
                  feedback.targetId = choice.target;
                } else {
                  feedback.targetId = stateId;
                }
              }
            }
          }
        }

        return feedback;
      },

      /**
       * Returns the model from the form/editor service
       *
       * @param {Object} model - Model
       * @param {Object} form - Form
       * @return {Object} Widget model
       */
      getModel: function getModel(model, form) {
        // make a deep clone of the model
        var modelCopy = _.cloneDeep(model);

        modelCopy.label = form.title;
        modelCopy.content.decisions.content.stem = form.stem;
        modelCopy.content.decisions.content.media = form.media;
        modelCopy.content.rules.content.decision.multiple = false;
        modelCopy.content.decisions.content.multiple = false;
        modelCopy.content.rules.content.scored = true;
        modelCopy.content.decisions.content.scored = true;
        modelCopy.content.rules.content.decision.maxAttempts = 1;
        modelCopy.content.rules.content.decision.correctTarget = form.choices[0].target;
        modelCopy.content.rules.content.decision.incorrectTarget = form.choices[0].target;
        modelCopy.content.rules.content.decision.choices[0].target = form.choices[0].target;
        modelCopy.content.rules.content.decision.choices[0].points = form.choices[0].points;
        modelCopy.content.decisions.content.choices[0].points = form.choices[0].points;
        modelCopy.content.decisions.content.choices[0].label = form.choices[0].value;
        modelCopy.content.rules.content.totalPoints = form.choices[0].points;

        return modelCopy;
      },

      /**
       * Configures the properties for the form editing process
       *
       * @param {Object} model - Model object
       * @return {Object} Form model object
       */
      configureForm: function configureForm(model) {
        var tinymceOptions = {
          menubar: false,
          plugins: 'advlist autolink lists link image charmap print preview hr anchor pagebreak table paste',
          toolbar: 'undo redo removeformat | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist | table | link unlink | subscript superscript',
          default_link_target: '_blank'
        };

        var text;
        var form = { schema: {}, form: {}, model: {} };
        var config = ModelsService.find('schemas', 'label', 'state.contentView');

        // make a deep clone of the model
        var modelCopy = _.cloneDeep(model);

        form.schema = config.content.schema;
        form.form = service.addStatesListToForm(config.content.form);

        // set items individually to determine format
        form.model.title = modelCopy.label;
        form.model.stem = modelCopy.content.decisions.content.stem;
        form.model.media = modelCopy.content.decisions.content.media;
        form.model.multiple = modelCopy.content.rules.content.decision.multiple;
        form.model.model = modelCopy.content.rules.content.decision.model;
        form.model.scored = modelCopy.content.rules.content.decision.scored;
        form.model.maxAttempts = modelCopy.content.rules.content.decision.maxAttempts;
        form.model.correctFeedback = modelCopy.content.rules.content.decision.correctFeedback;
        form.model.incorrectFeedback = modelCopy.content.rules.content.decision.incorrectFeedback;
        form.model.correctTarget = modelCopy.content.rules.content.decision.correctTarget;
        form.model.incorrectTarget = modelCopy.content.rules.content.decision.incorrectTarget;
        form.model.choices = [];

        _.forEach(modelCopy.content.rules.content.decision.choices, function (choice, index) {
          var entry = {};
          entry.points = choice.points;
          entry.target = choice.target;
          entry.correct = choice.correct;
          entry.feedback = choice.feedback;
          entry.incorrectFeedback = choice.incorrectFeedback;
          entry.correctFeedback = choice.correctFeedback;
          entry.value = model.content.decisions.content.choices[index].label;

          form.model.choices.push(entry);
        });

        // Title
        text = {
          type: 'horizontal-text',
          key: 'title',
          offset: 1
        };

        form.form.splice(0, 1, text);

        // media
        form.form[1].type = 'horizontal-array';
        form.form[1].collapseTitle = 'Media Items';
        form.form[1].offset = 1;
        form.form[1].notitle = false;
        form.form[1].style = {
          add: 'btn-link'
        };

        // html editor
        form.form[2].offset = 1;
        form.form[2].type = 'wysiwyg';
        form.form[2].tinymceOptions = tinymceOptions;

        // Buttons
        form.form[3].type = 'horizontal-array';
        form.form[3].collapseTitle = 'Details';
        form.form[3].offset = 1;
        form.form[3].remove = null;

        console.log(form.form);

        return form;
      },

      /**
       * Returns a form with the StateListTitleMap variable
       * replaced with correct data
       *
       * @param {Array<Object>} form - Form collection
       * @return {Array<Object>} form
       */
      addStatesListToForm: function addStatesListToForm(form) {
        var reg = new RegExp(/\["StateListTitleMap"\]/, 'g');
        var map = JSON.stringify(StatesService.getStatesListTitleMap());

        return JSON.parse(JSON.stringify(form).replace(reg, map));
      }
    };

    return service;
  }
]);
